module.exports = __webpack_public_path__ + "img/jiaoyu1.6b291d42.png";